import moment from "moment"
import React from "react"
const PinComponent = props => {
  const date1 = moment()
  const date2 = moment(props.item?.created)
  const dateLastVisit = moment(props.item?.vehicleLastVisit?.visitDate)
  const diff = date1.diff(date2, "days")
  const diffLastVisit = date1.diff(dateLastVisit, "days")
  const styleProp = {
    color:
      props.item && props.item.assignedTo && props.item.assignedToObj.color
        ? props.item.assignedToObj.color
        : diff < 14
        ? "#7ac2ff"
        : diff < 30
        ? "#034986ff"
        : diff < 60
        ? "#222bd9ff"
        : "#7a7a7a",
    border: "0",
  }

  const textColor =
    props.item && props.item.assignedTo && props.item.assignedToObj.color
      ? "black !important"
      : diff < 14
      ? "#7ac2ff"
      : diff < 30
      ? "#034986ff"
      : diff < 60
      ? "#002f58ff"
      : "#7a7a7a"

  const textColorVehicleVisits =
    props.item && props.item.vehicleVisit
      ? diffLastVisit < 7
        ? "#7ac2ff"
        : diffLastVisit < 14
        ? "#034986ff"
        : diffLastVisit < 30
        ? "#002f58ff"
        : "black !important"
      : null

  const iconDisplay =
    props.Type === "vehicle"
      ? "fa fa-map-marker"
      : (props.item && props.item.category.icon) ??
        props.item?.stage?.icon ??
        "fa fa-map-marker"

  const statusStyle = item => {
    let result =
      item && item.placeStatus ? (
        <i
          className={" circle  " + " hasVisit "}
          style={{
            backgroundColor: item.placeStatus.color,
          }}
        ></i>
      ) : null
    return result
  }
  const vehicleVisitStyle = () => {
    // console.log("vehicleVisitStyle", props)
    if (props && !props.item.vehicleVisit) {
      return null
    }
    // console.log(
    //   "vehicleVisitStyle",
    //   props.item?.vehicleLastVisit?.visitDate,
    //   textColorVehicleVisits,
    //   props.item?.vehicleVisit,
    //   props.item?.vehicleLastVisit?.visitDate
    // )
    let result = (
      <i
        className={" fa-solid fa-circle-xmark  hasVisitFromVehicle "}
        style={{
          color: textColorVehicleVisits,
          background: "white",
          fontSize: "16px",
        }}
      ></i>
    )

    return result
  }

  if (props.Type === "vehicle") {
    return (
      <div
        className={"fa-solid fa-circle fa-3x  "}
        title={props.item.text}
        style={{
          color: "orange",
          border: "0",
        }}
        onClick={() => {
          props.toggle(props.item)
        }}
      >
        {props.item && props.item.assignedTo ? (
          <span className="text-white pinText" style={{ color: textColor }}>
            {props.item.assignedToObj.firstName.substring(0, 1)}
          </span>
        ) : (
          <i
            className={`text-white fa fa-truck`}
            title={props.text}
            style={{
              fontSize: "0.4em",
              position: "absolute",
              left: "0.70em",
              top: "9px",
              color: textColor,
            }}
          />
        )}
        {statusStyle(props.item)}
      </div>
    )
  }
  //REGULAR ICONS

  return (
    <div
      className={
        (props.Type === "vehicle"
          ? "fa-solid fa-truck"
          : "fa-solid fa-location-pin") + " fa-3x "
      }
      title={
        (props.item?.creditCode ? props.item.creditCode + " " : "") +
        (props.item?.name ? props.item.name + " " : "") +
        (props.item?.category ? "Categoria: " + props.item.category.name : "") +
        " " +
        (props.item?.stage ? "Etapa: " + props.item?.stage.name : "")
      }
      style={styleProp}
      onClick={() => {
        props.toggle(props.item)
      }}
    >
      {props.item && props.item.assignedTo ? (
        <span className="text-white pinText" style={{ color: textColor }}>
          {props.item.assignedToObj.firstName.substring(0, 1)}
        </span>
      ) : (
        <i
          className={`text-white ${iconDisplay}`}
          title={props.text}
          style={{
            fontSize: "0.4em",
            position: "absolute",
            left: "0.50em",
            top: "5px",
            color: textColor,
          }}
        />
      )}
      {statusStyle(props.item)}

      {vehicleVisitStyle()}
    </div>
  )
}

export default PinComponent
